import { render, staticRenderFns } from "./AppointmentsTabController.vue?vue&type=template&id=a317f534&scoped=true&"
import script from "./AppointmentsTabController.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsTabController.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentsTabController.vue?vue&type=style&index=0&id=a317f534&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a317f534",
  null
  
)

export default component.exports